import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowRightSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor" d="M21.5 13.5H6m15.5 0L18 17m3.5-3.5L18 10"></path>
    </svg>
)

const ArrowRightKeyboard: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowRightSvg}
    </SvgIcon>
)

export default ArrowRightKeyboard